<template>
  <div class="page-body">
    <div :class="['menu-dialog', showMenu && 'show']">
      <img
        @click="showMenu = false"
        class="close-btn"
        src="../static/mobile/close.png"
        alt=""
      />
      <a
        @click="showMenu = false"
        :class="[
          'menuItem',
          (!$route.hash || $route.hash.includes('#index')) && 'active'
        ]"
        href="#index"
        >首页</a
      >
      <a
        @click="showMenu = false"
        :class="[
          'menuItem',
          !$route.hash || ($route.hash.includes('#aboutUs') && 'active')
        ]"
        class="menuItem"
        href="#aboutUs"
        >关于我们</a
      >
      <a
        @click="showMenu = false"
        :class="[
          'menuItem',
          !$route.hash || ($route.hash.includes('#production') && 'active')
        ]"
        class="menuItem"
        href="#production"
        >我们产品</a
      >
      <a
        @click="showMenu = false"
        :class="[
          'menuItem',
          !$route.hash || ($route.hash.includes('#contactUs') && 'active')
        ]"
        class="menuItem"
        href="#contactUs"
        >联系我们</a
      >
    </div>
    <div class="menu-cover" v-if="showMenu" @click="showMenu = false"></div>
    <div class="nav-bar">
      <a href="#index" class="logo">
        Metro大都会
      </a>
      <a href="javascript:void(0)" class="menu-btn" @click="showMenu = true">
      </a>
    </div>
    <div id="index" class="section index">
      <div class="index-title">
        <img src="../static/mobile/index-title.png" alt="" />
        <a
          class="download-btn"
          href="http://anijue.shmetro.com/p/q/fd-jhm0hlmg/pages/share/index.html?chlnfo=zhifubaopr0612"
          target="_blank"
        ></a>
      </div>
      <img
        class="index-mobile"
        src="../static/mobile/index-mobile.png"
        alt=""
      />
    </div>
    <div id="aboutUs" class="section aboutUs">
      <img
        class="aboutUs-desc"
        src="../static/mobile/aboutUs-desc.png"
        alt=""
      />
    </div>
    <div id="production" class="section production">
      <img
        class="production-desc"
        src="../static/mobile/production-desc.png"
        alt=""
      />
    </div>
    <div class="section production-p2">
      <div class="content-wrapper">
        <h1>Metro大都会功能介绍</h1>
        <img
          class="production-list"
          src="../static/mobile/production-list.png"
          alt=""
        />
      </div>
    </div>
    <div class="section production-p3">
      <img
        class="production-p3-desc"
        src="../static/mobile/production-p3-desc.png"
        alt=""
      />
    </div>
    <div class="section production-p4">
      <img
        class="production-p4-desc"
        src="../static/mobile/production-p4-desc.png"
        alt=""
      />
    </div>
    <div id="contactUs" class="section contactUs">
      <img
        class="contactUs-banner"
        src="../static/mobile/contactUs-banner.png"
        alt=""
      />
      <div>
        <img
          class="contactUs-desc"
          src="../static/mobile/contactUs-desc.png"
          alt=""
        />
      </div>
      <div class="contactUs-footer">
        <div class="contactUs-footer-desc">
          <div class="reportWrapper">
            互联网违法和不良信息举报电话
            <span class="report"
              ><span>12321</span> <span>64370000-8-1</span></span
            >
          </div>
          <div>
            Copyright © 都世通网络科技有限公司 版权所有 All Rights Reserved.
          </div>
          <div>
            <a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011202005614"
              target="_blank"
              rel="noopener noreferrer"
              style="color:#fff"
              ><img src="../static/mobile/beian.png" alt="" /> 沪公网安备
              31011202005614号</a
            >
          </div>
          <a style="color:#fff" href="https://beian.miit.gov.cn" target="_blank"
            >沪ICP备19036711号-1</a
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showMenu: false,
      options: {
        licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        menu: '#menu',
        navigation: true,
        anchors: [
          'index',
          'aboutUs',
          'production',
          'production-p2',
          'production-p3',
          'production-p4',
          'contactUs'
        ]
      }
    };
  },
  created() {},
  computed: {},
  methods: {}
};
</script>
<style lang="less" scoped>
.font(@fontSize: 30px, @color: #fff, @fontWeight: 400, @fontFamily: PingFangSC-Regular) {
  .size(@fontSize, font-size);
  .font-weight(@fontWeight);
  color: @color;
}

.font-weight(@fontWeight: @FontBold) {
  font-weight: @fontWeight;
}
.size(@s, @rest...) {
  .loop(@iterator: 1) when(length(@rest) >=@iterator) {
    @property: extract(@rest, @iterator);
    @{property}: @s - 0rpx;
    .loop(@iterator + 1);
  }

  .loop(1);
}
.page-body {
  .menu-dialog {
    position: fixed;
    height: 150vh;
    width: 70vw;
    right: -100%;
    top: 0;
    z-index: 1000;
    background: #fff;
    transition: right 0.3s ease-in;

    &.show {
      right: 0;
    }
    .close-btn {
      width: 20px;
      height: 20px;
      padding: 15px;
    }
    .menuItem {
      display: block;
      text-align: center;
      color: #000;
      line-height: 60px;
      &.active {
        font-weight: bold;
      }
    }
  }
  .menu-cover {
    position: fixed;
    left: 0;
    top: 0;
    width: 100vw;
    height: 150vh;
    z-index: 800;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .nav-bar {
    position: fixed;
    box-sizing: border-box;
    left: 0;
    top: 0;
    width: 100%;
    height: 51px;
    padding: 16px;
    background: url(../static/mobile/header-bg.png) left top / 100% auto
      no-repeat;
    z-index: 10;
    display: flex;
    justify-content: space-between;
    .logo {
      color: #fff;
      width: 119px;
      height: 21px;
      line-height: 21px;
      padding-left: 31px;
      font-size: 12px;
      background: url(../static/mobile/logo.png) left center / contain no-repeat;
    }
    .menu-btn {
      padding: 10px;
      background: url(../static/mobile/menu-btn.png) center center / 16px 13px
        no-repeat;
    }
  }
  .index {
    height: 80vh;
    overflow: hidden;
    position: relative;
    background: url('../static/mobile/index-bg.png') center center/100% 100%
      no-repeat;
    .index-title {
      width: 80%;
      position: absolute;
      top: calc(0.4rem + 51px);
      left: 50%;
      transform: translateX(-50%);
      > img {
        width: 100%;
      }
    }
    .download-btn {
      position: absolute;
      bottom: -50px;
      display: block;
      width: 74px;
      height: 36px;
      background: url(../static/mobile/download.png) center center/100% 100%
        no-repeat;
    }
    .index-mobile {
      width: 120%;
      position: absolute;
      bottom: 0.3rem;
      left: 0.5rem;
    }
  }
  .aboutUs {
    height: 54vh;
    background: #fff url('../static/mobile/aboutUs-bg.png') right top/auto 100%
      no-repeat;
    position: relative;
    .aboutUs-desc {
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .production {
    height: 56vh;
    background: #fff url('../static/mobile/production.png') right top/auto 100%
      no-repeat;
    position: relative;
    .production-desc {
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .production-p2 {
    height: 66vh;
    background: url(../static/mobile/production-p2-bg.png) center top / 100%
      100% no-repeat;
    position: relative;
    .content-wrapper {
      width: 100vw;
      height: 6rem;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      text-align: center;
      h1 {
        display: inline-block;
        .font(0.5rem, #5583e6);
        position: relative;
        &::before,
        &::after {
          content: '';
          position: absolute;
          width: 1.13rem;
          height: 0.03rem;
          background: url(../static/mobile/wing.png) center center no-repeat;
          left: -1.2rem;
          top: 50%;
          transform: translate(0, -50%);
        }
        &::after {
          left: unset;
          right: -1.2rem;
        }
      }
      .production-list {
        margin-top: 0.5rem;
        width: 80%;
      }
    }
  }
  .production-p3 {
    height: 66vh;
    background: #fff url('../static/mobile/production-p3.png') right top/auto
      100% no-repeat;
    position: relative;
    .production-p3-desc {
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .production-p4 {
    height: 90vh;
    background: url('../static/mobile/production-p4.png') center center/100%
      100% no-repeat;
    position: relative;
    .production-p4-desc {
      width: 70%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .contactUs {
    background-color: #fff;
    .contactUs-banner {
      display: block;
      width: 100%;
    }
    .contactUs-desc {
      width: 80%;
      padding: 30px 0;
      margin: 0 auto;
      display: block;
    }
    .contactUs-footer {
      background-color: rgb(101, 102, 107);
      width: 100%;
      height: 80px;
      color: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      .contactUs-footer-desc {
        line-height: 15px;
        white-space: nowrap;
        transform: scale(0.6);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        line-height: 30px;
        .reportWrapper {
          position: relative;
          .report {
            position: absolute;
            left: 15em;
            top: 50%;
            transform: translateY(-50%);
            color: rgb(101, 102, 107);
            > span {
              margin-right: 10px;
              padding: 0px 8px;
              background-color: #b8b8b8;
              border-radius: 5px;
            }
          }
        }
        a {
          position: relative;
          img {
            position: absolute;
            left: -26px;
            top: 50%;
            transform: translateY(-50%);
          }
        }
      }
      .followUs {
        width: 2.72rem;
        height: 2.13rem;
        position: absolute;
        top: -1.03rem;
        right: 1.5rem;
      }
    }
  }
}
</style>
